import { accountApi } from '../../../redux/api/AccountApi';
import { CommonListQuery } from '../../../redux/api/apiTypes';
import productApi from '../../../redux/api/ProductApi';
import { AuctionList } from '../../auction/types';
import { UpdateUser, User } from '../../common/types/types';
import {
    AuctionHistoryList, AuctionHistoryResponse, AuctionHistorySearch,
    ChangePassword, PrepayList, ProductCareSearch, PrepaySearch,
    PrepayAuction,
    PrepayResponse,
} from '../types';

export const profileApi = accountApi.injectEndpoints({
    endpoints: (builder) => ({
        updateProfile: builder.mutation<User, UpdateUser>({
            query: (body) => ({
                url: `update-profile`,
                method: 'PUT',
                body
            }),
            transformResponse: (response: { body: User }, meta, arg) => {
                return response.body;
            }
        }),
        changePassword: builder.mutation<User, ChangePassword>({
            query: (body) => ({
                url: `change-pass`,
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: User }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const profileProductApi = productApi.injectEndpoints({
    endpoints: (builder) => ({
        getProductCareList: builder.query<AuctionList, ProductCareSearch>({
            query: (body) => {
                const { page, size, keyword, ...rest } = body;
                return ({
                    url: `care/search?page=${page}&size=${size}&keyword=${keyword || ""}&properties=modifiedDate&sortBy=DESC`,
                    method: 'POST',
                    body: rest
                })
            },
            transformResponse: (response: { body: AuctionList }, meta, arg) => {
                return response.body;
            }
        }),
        getListHistoryAction: builder.query<AuctionHistoryList, AuctionHistorySearch>({
            query: (body) => {
                const { page, size, keyword, ...rest } = body;
                return ({
                    url: `auction-register/list-history-action-max-bidder?page=${page}&size=${size}&keyword=${keyword || ""}&properties=modifiedDate&sortBy=DESC`,
                    method: 'POST',
                    body: rest
                })
            },
            transformResponse: (response: { body: AuctionHistoryList }, meta, arg) => {
                return response.body;
            }
        }),
        getRegisterAuctionDetail: builder.query<AuctionHistoryResponse, number>({
            query: (id) => `auction-register/detail/${id}`,
            transformResponse: (response: { body: AuctionHistoryResponse }, meta, arg) => {
                return response.body;
            }
        }),
        getListPrepayment: builder.query<PrepayList, PrepaySearch>({
            query: (body) => {
                const { page, size, keyword, ...rest } = body;
                return ({
                    url: `prepay/list-prepayment?page=${page}&size=${size}&keyword=${keyword || ""}&properties=modifiedDate&sortBy=DESC`,
                    method: 'POST',
                    body: rest
                })
            },
            transformResponse: (response: { body: PrepayList }, meta, arg) => {
                return response.body;
            }
        }),
        prepayAuction: builder.mutation<PrepayResponse, PrepayAuction>({
            query: (body) => ({
                url: `prepay`,
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: PrepayResponse }, meta, arg) => {
                return response.body;
            }
        }),
        exportListHistoryAction: builder.mutation<any, AuctionHistorySearch & CommonListQuery>({
            query: (body) => {
                const { page, size, keyword, ...rest } = body;
                return ({
                    url: `auction-register/export-list-history-action?page=${page}&size=${size}&keyword=${keyword || ""}&properties=modifiedDate&sortBy=DESC`,
                    method: 'POST',
                    body: rest
                })
            },
            transformResponse: (response: { body: any }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const {
    useUpdateProfileMutation,
    useChangePasswordMutation } = profileApi;

export const {
    useLazyGetProductCareListQuery,
    useLazyGetListHistoryActionQuery,
    useLazyGetRegisterAuctionDetailQuery,
    useLazyGetListPrepaymentQuery,
    usePrepayAuctionMutation,
    useExportListHistoryActionMutation } = profileProductApi;